import { definePreset } from '@primevue/themes'
import Aura from '@primevue/themes/aura'

/**
 * Preset de PrimeVue usando SOLO los colores del branding Poseidonie
 * 
 * Modo Claro: Fondos blancos + Textos Negro
 * Modo Oscuro: Fondos Negro + Textos Blanco/Grises
 */
export const PoseidoniePreset = definePreset(Aura, {
  semantic: {
    primary: {
      50: '#f5f5f5',
      100: '#e8e8e8',
      200: '#8A8A8A',    // brand.cloud (gris claro)
      300: '#4A4A4A',    // brand.slate (gris medio)
      400: '#2A2A2A',
      500: '#000000',    // brand.navy - BASE (negro)
      600: '#000000',
      700: '#000000',
      800: '#000000',
      900: '#000000',
    },
    colorScheme: {
      light: {
        primary: {
          color: '#000000',           // brand.navy (negro) - fuerte y profesional
          contrastColor: '#FFFFFF',   // brand.white
          hoverColor: '#2A2A2A',
          activeColor: '#000000',
        },
        surface: {
          0: '#FFFFFF',              // brand.white
          50: '#FFFFFF',             // white
          100: '#FFFFFF',            // white
          200: '#FFFFFF',            // white
          300: '#8A8A8A',            // brand.cloud (gris claro)
          400: '#4A4A4A',            // brand.slate (gris medio)
          500: '#2A2A2A',
          600: '#000000',            // brand.navy (negro)
          700: '#000000',
          800: '#000000',
          900: '#000000',
        },
        text: {
          color: '#000000',          // brand.navy (negro)
          secondaryColor: '#4A4A4A', // brand.slate (gris medio)
          mutedColor: '#8A8A8A',     // brand.cloud (gris claro)
        },
      },
      dark: {
        primary: {
          color: '#8A8A8A',           // brand.cloud (gris claro) - suave y visible en oscuro
          contrastColor: '#000000',   // brand.navy (negro)
          hoverColor: '#9A9A9A',
          activeColor: '#7A7A7A',
        },
        surface: {
          0: '#000000',
          50: '#0A0A0A',
          100: '#1A1A1A',
          200: '#000000',            // brand.navy (negro) - BASE OSCURO
          300: '#2A2A2A',
          400: '#4A4A4A',            // brand.slate (gris medio)
          500: '#8A8A8A',            // brand.cloud (gris claro)
          600: '#FFFFFF',
          700: '#FFFFFF',
          800: '#FFFFFF',
          900: '#FFFFFF',
        },
        text: {
          color: '#FFFFFF',
          secondaryColor: '#8A8A8A', // brand.cloud (gris claro)
          mutedColor: '#4A4A4A',     // brand.slate (gris medio)
        },
      },
    },
  },
  primitive: {
    // Colores del branding - referencia directa
    borderRadius: {
      none: '0',
      xs: '4px',
      sm: '8px',
      md: '12px',
      lg: '16px',
      xl: '20px',
    },
    // Tipografía
    fontFamily: {
      primary: "'New York', Georgia, 'Times New Roman', serif",
      secondary: "system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif",
    },
  },
  components: {
    button: {
      colorScheme: {
        light: {
          primary: {
            background: '#000000',        // brand.navy (negro)
            hoverBackground: '#2A2A2A',
            activeBackground: '#000000',
            borderColor: '#000000',
            hoverBorderColor: '#2A2A2A',
            color: '#FFFFFF',
          },
          secondary: {
            background: '#4A4A4A',        // brand.slate (gris medio)
            hoverBackground: '#5A5A5A',
            activeBackground: '#3A3A3A',
            borderColor: '#4A4A4A',
            hoverBorderColor: '#5A5A5A',
            color: '#FFFFFF',
          },
        },
        dark: {
          primary: {
            background: '#8A8A8A',        // brand.cloud (gris claro)
            hoverBackground: '#9A9A9A',
            activeBackground: '#7A7A7A',
            borderColor: '#8A8A8A',
            hoverBorderColor: '#9A9A9A',
            color: '#000000',             // brand.navy (negro)
          },
          secondary: {
            background: '#4A4A4A',        // brand.slate (gris medio)
            hoverBackground: '#5A5A5A',
            activeBackground: '#3A3A3A',
            borderColor: '#4A4A4A',
            hoverBorderColor: '#5A5A5A',
            color: '#FFFFFF',
          },
        },
      },
    },
  },
})
